// extracted by mini-css-extract-plugin
module.exports = {"blockMTSFooter":"mts-footer_blockMTSFooter__3CYW0","blockMTSFooterMobile":"mts-footer_blockMTSFooterMobile__1oDTw"};